import {AfterViewInit, Component, DestroyRef, inject, Injector, signal, viewChild} from '@angular/core';
import {ResultsTableRowComponent} from './results-table-row/results-table-row.component';
import {IItem} from '../../../../types/IItem';
import {IColumnConfig} from '../../../../types/IColumnConfig';
import {ResultTableService} from '../../services/result-table.service';
import {ResultsTableHeaderColumnComponent} from './results-table-header-column/results-table-header-column.component';
import {ResultsStore} from '../../../../shared/store/results.store';
import {AppStore} from '../../../../shared/store/app.store';
import {CdkVirtualScrollViewport, CdkVirtualForOf, CdkFixedSizeVirtualScroll} from '@angular/cdk/scrolling';
import {combineLatest, debounceTime} from 'rxjs';
import {toObservable, takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {ButtonComponent} from '../../../../shared/components/button/button.component';
import {IconsComponent} from '../../../../shared/components/icons/icons.component';
import {getFirstMap} from '../../../../shared/utils/availability.utils';
import {ResultsItemDetailsModal} from '../results-item-details-modal/results-item-details-modal';
import {ResultsItemSupplierSelectionModal} from '../results-item-supplier-selection-modal/results-item-supplier-selection-modal';

@Component({
  selector: 'app-results-table',
  standalone: true,
  imports: [ResultsTableRowComponent, ResultsTableHeaderColumnComponent, CdkVirtualScrollViewport, CdkVirtualForOf, CdkFixedSizeVirtualScroll, ButtonComponent, IconsComponent, ResultsItemDetailsModal, ResultsItemSupplierSelectionModal],
  templateUrl: './results-table.component.html',
  styleUrl: './results-table.component.css'
})
export class ResultsTableComponent implements AfterViewInit {
  viewport = viewChild.required(CdkVirtualScrollViewport);

  showScrollToTop = signal(false);

  public resultsStore = inject(ResultsStore);
  public resultTableService = inject(ResultTableService);
  appStore = inject(AppStore);
  private destroyRef = inject(DestroyRef);
  private injector = inject(Injector);

  trackByItem(_index: number, item: IItem): string | number {
    return item.id;
  }

  scrollToTop() {
    this.viewport().scrollTo({top: 0, behavior: 'smooth'});
  }

  ngAfterViewInit() {
    this.viewport().elementScrolled().pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.showScrollToTop.set(this.viewport().measureScrollOffset('top') >= 300);
    });

    combineLatest([
      this.viewport().renderedRangeStream,
      toObservable(this.resultTableService.allRows, {injector: this.injector}),
      toObservable(this.resultsStore.currentPriceLevel, {injector: this.injector}),
    ]).pipe(
      debounceTime(100),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(([range, items]) => {
      const visible = items.slice(range.start, range.end);
      if (!visible.length) return;
      this.resultsStore.fetchPricing({
        price_level_id: this.resultsStore.currentPriceLevel()?.id,
        customer_id: undefined,
        repair_order_id: this.appStore.cart()?.repair_order?.repair_order_id,
        items: visible.map(item => ({
          item_id: item.id,
          brand: item.brand,
          model: item.model,
          item_number: item.item_number,
          costs: [...new Set(item.availability.map(({cost}) => cost)).add(item.cost)],
          map: getFirstMap(item.availability),
        }))
      });
    });
  }
}
